export class TvAccountMarginData {
    public initialMarginReq: number = 0;
    public initialMarginReqPercent: number = 0;
    public maintMarginReq: number = 0;
    public maintMarginReqPercent: number = 0;
    public marginWarningLevel: number = 0;
    public marginAvailable: number = 0;
    public warningMargin: number = 0;
    public blockedForStocks: number = 0;
    public stocksOrdersReq: number = 0;
}
